export enum ELocalizedDateFormat {
  l = 'L',
  ll = 'll',
}
